// extracted by mini-css-extract-plugin
module.exports = {"applyButton":"applyButton--Y9AVo","switch":"switch--2nw-p","alwaysOn":"alwaysOn--3VG3s"};